// Viewport
export const SET_VIEWPORT = 'viewport/SET_VIEWPORT';
export const SET_PAGE_VISIBILITY = 'viewport/SET_PAGE_VISIBILITY';

// Scroll
export const SET_SCROLL = 'scroll/SET_SCROLL';
export const DISABLE_SCROLL = 'scroll/DISABLE_SCROLL';

// Overlay
export const OPEN_OVERLAY = 'overlay/OPEN_OVERLAY';
export const REGISTER_OVERLAY = 'overlay/REGISTER_OVERLAY';
export const UNREGISTER_OVERLAY = 'overlay/UNREGISTER_OVERLAY';
export const CLOSE_OVERLAY = 'overlay/CLOSE_OVERLAY';

export const MAIN_NAV_VISIBILITY = 'navigation/MAIN_NAV_VISIBILITY';
export const SET_PREVIEW_LINKS = 'navigation/SET_PREVIEW_LINKS';
export const SET_PREVIEW_VISIBILITY = 'navigation/SET_PREVIEW_VISIBILITY';
export const SET_PREVIEW_CONTENT = 'navigation/SET_PREVIEW_CONTENT';
export const SET_PREVIEW_ANCHOR_POS = 'navigation/SET_PREVIEW_ANCHOR_POS';
export const SET_INITIAL_PREVIEW_ANCHOR_POS = 'navigation/SET_INITIAL_PREVIEW_ANCHOR_POS';
export const SET_METANAV_LINKS = 'navigation/SET_METANAV_LINKS';
export const SET_REDUCED_NAV_VISIBILITY = 'navigation/SET_REDUCED_NAV_VISIBILITY';
export const SET_PREVIEW_CONTENT_UID = 'navigation/SET_PREVIEW_CONTENT_UID';

export const SET_PAYMENTMETHOD_ITEMS = 'payment-methods/SET_PAYMENTMETHOD_ITEMS';
export const SET_PAYMENTMETHOD_ITEM_OVERLAYREF = 'payment-methods/SET_PAYMENTMETHOD_ITEM_OVERLAYREF';

export const SET_BREADCRUMBS_FACET = 'breadcumbs/SET_FACET';

export const SET_COOKIE_GROUPS = 'cookie/SET_COOKIE_GROUPS';
export const SET_COOKIE_ACK = 'cookie/SET_COOKIE_ACK';

export const SET_PAGE_LOADING = 'SET_PAGE_LOADING';
